import React, { useEffect, useRef } from "react";

const LedMatrix = ({
  line1 = "",
  color1 = "#FF8C00",
  bgColor = "#000000",
}) => {
  const canvasRef = useRef(null);

  const DOT_SIZE = 1.5;
  const DOT_GAP = 2;
  const FONT_SIZE = 22;
  const SPEED = 2;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const width = canvas.width;
    const height = canvas.height;

    let offset = width;

    function drawCenteredText(text, color) {
      // clear
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, width, height);

      // font
      ctx.font = `${FONT_SIZE}px 'Arial Black'`;
      ctx.fillStyle = color;

      // ✅ vertical center
      const m = ctx.measureText(text);
      const ascent = m.actualBoundingBoxAscent || FONT_SIZE;
      const descent = m.actualBoundingBoxDescent || 0;
      const y = (height + ascent - descent) / 2;

      // draw text
      ctx.fillText(text, offset, y);

      // LED dots effect
      const imgData = ctx.getImageData(0, 0, width, height);
      const data = imgData.data;

      for (let i = 0; i < data.length; i += 4) {
        const brightness = data[i] + data[i + 1] + data[i + 2];
        const x = (i / 4) % width;
        const yPos = Math.floor(i / 4 / width);

        if (x % (DOT_SIZE + DOT_GAP) === 0 && yPos % (DOT_SIZE + DOT_GAP) === 0) {
          ctx.fillStyle = brightness > 100 ? color : bgColor;
          ctx.fillRect(x, yPos, DOT_SIZE, DOT_SIZE);
        }
      }
    }

    function animate() {
      drawCenteredText(line1, color1);

      offset -= SPEED;
      if (offset < -width) offset = width;

      requestAnimationFrame(animate);
    }

    animate();
  }, [line1, color1, bgColor]);

  return (
    <canvas
      ref={canvasRef}
      width={400}
      height={81}
      style={{
        background: bgColor,
        width: "400px",
        height: "81px",
        display: "block",
      }}
    />
  );
};

export default LedMatrix;
